/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './EmailSubscriptionDataServiceEntities.g';

// @ts-ignore
function emailSubscriptionsQuery(unique_id?: string): DataServiceQuery {
    const key = unique_id ? { unique_id: unique_id } : null;
    return new DataServiceQuery('EmailSubscriptions', 'MFIEmailSubscription', DataServiceEntities.MFIEmailSubscriptionExtensionClass, key);
}

export function createMFIEmailSubscriptionInput(emailSignup: DataServiceEntities.IMFIEmailSubscription): IDataServiceRequest {
    const query = emailSubscriptionsQuery();
    return query.createDataServiceRequestForOperation(
        'MFIEmailSubscription',
        true,
        DataServiceEntities.MFIEmailSignupResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIEmailSignupResponse' },
        { emailSignup: emailSignup }
    );
}

export function mFIEmailSubscriptionAsync(
    context: IContext,
    emailSignup: DataServiceEntities.IMFIEmailSubscription
): AsyncResult<DataServiceEntities.IMFIEmailSignupResponse> {
    const request = createMFIEmailSubscriptionInput(emailSignup);
    return callActionOrExecute<DataServiceEntities.IMFIEmailSignupResponse>(request, context.callerContext);
}
